module.exports = __webpack_public_path__ + "static/media/apple-1.c57a1b5f.glb";